import React from 'react'
import { css, SerializedStyles } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { ReservationTaskReservationStatus, reservationTaskReservationStatusLabelKeys } from '@/models/reservation/reservation-task'
import { RESERVATION_TASK_STATUS_COLORS } from './status-colors'

type Props = {
  status: ReservationTaskReservationStatus
}

export const ReservationTaskStatusLabel: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation()
  return <div css={[labelStyle, labelColorStyles[status]]}>{t(reservationTaskReservationStatusLabelKeys[status])}</div>
}

// 寸法は予約タブ（_reservation/list.tsx）の枠線ラベルに合わせる。予約タブは新規以外をグレーにしているが、
// タスク管理はモックに合わせて更新を赤（宿泊ステータス「チェックイン」と同じ色）に分ける
const labelStyle = css({
  width: 88,
  height: 22,
  padding: '0 10px',
  border: '1px solid currentColor',
  borderRadius: 5,
  fontSize: 12,
  lineHeight: '20px',
  textAlign: 'center',
})

const labelColorStyles: Record<ReservationTaskReservationStatus, SerializedStyles> = {
  [ReservationTaskReservationStatus.New]: css({ color: RESERVATION_TASK_STATUS_COLORS.yellow }),
  [ReservationTaskReservationStatus.Updated]: css({ color: RESERVATION_TASK_STATUS_COLORS.red }),
  [ReservationTaskReservationStatus.Canceled]: css({ color: RESERVATION_TASK_STATUS_COLORS.gray }),
}
